import React from "react";
import { FaLongArrowAltDown } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { FaLaptopCode } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { FaThLarge } from "react-icons/fa";


const Header = () => {
  const menuItems = (
    <>
      <li>
        <a href="#home"><FaHome/> <span className="text-secondary">Home</span></a>
      </li>
      <li>
        <a href="#about"><FaUserCircle/> <span className="text-secondary">About Me</span></a>
      </li>
      <li>
        <a href="#projects"><FaLaptopCode/> <span className="text-secondary">Projects</span></a>
      </li>
      <li>
        <a href="#blogs"><FaThLarge/> <span className="text-secondary">Blogs</span></a>
      </li>
      <li>
        <a href="#contact"><FaAddressCard/> <span className="text-secondary">Contact Me</span></a>
      </li>
    </>
  );
  return (
    <section id="#home" className="sticky top-0">
      <div class="navbar bg-base-400 text-white">
        <div class="navbar-start">
          <div class="dropdown">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabindex="0"
              class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-500 text-accent rounded-box w-52"
            >
              {menuItems}
            </ul>
          </div>
          <a href="#" class="btn btn-ghost normal-case text-secondary text-center text-3xl text-primary font-serif font-bold my-9">
            PORTFOLIO.
          </a>
        </div>
        <div class="navbar-center hidden lg:flex text-xl text-accent font-serif">
          <ul class="menu menu-horizontal font-bold p-0">{menuItems}</ul>
        </div>
        <div class="navbar-end">
          <a
            href="https://drive.google.com/file/d/1ayyz_lWvi2AqY8PuH1Nvqwh7Ko1fV59-/view?usp=sharing"
            class="btn text-xl font-medium text-secondary"
          >
            Resume <FaLongArrowAltDown />{" "}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Header;
